import React, {Suspense} from 'react';
import {Redirect, useLocation} from 'react-router-dom';
import {observer} from 'mobx-react-lite'

import userStore from "common/user/store/UserStore";
import PageLoading from "components/loading";
import loadingStore from "common/page/store/LoadingStore";
import {PasswordProvider} from "common/hooks/PasswordContext";
import menuStore from "../../common/menu/store/MenuStore";

interface PageContainerProps {
    children: React.ReactNode;
    session?: boolean
}

export default observer(function ({children, session = true}: PageContainerProps) {
    const location = useLocation();
    const originalUrl = location.pathname;
    const isAdmin = location.pathname.includes("/admin");

    if (session && !userStore.userModel) {
        // const redirectUrl = userStore.getLoginUrl(isAdmin) + `?url=${originalUrl}`;
        return <Redirect to={{
            pathname: userStore.getLoginUrl(isAdmin),
            search: `?url=${originalUrl}`
        }} />
    } else {
        const authorities = userStore.userModel?.getAuthorities() || ["ROLE_ANONYMOUS"];
        let casAccess = false;
        const activeMenuList = menuStore.menuList?.find(menu => menu.active);
        if (activeMenuList)
            casAccess = authorities.some(auth => menuStore.menuList?.filter(menu => menu.active)?.some(menu => menu.getAuthorities().includes(auth)))
        else
            casAccess = true;

        if (casAccess && isAdmin)
            casAccess = userStore.canAdminAccess()

        casAccess = casAccess || originalUrl === '/admin/adm_login/admlogin' || originalUrl === '/main/usr_1000/usr_1300';

        if (!casAccess) {
            const redirectUrl = userStore.getLoginUrl(isAdmin);
            return <Redirect to={redirectUrl}/>
        }

        return (
            <div className="fww-group-aside-con">
                <PasswordProvider>
                    <Suspense fallback={<PageLoading/>}>
                        {children}
                    </Suspense>
                </PasswordProvider>
                {loadingStore.requestCnt != 0 && <PageLoading/>}
            </div>
        );
    }
});